<template>
  <div class="tabs-section">
    <div class="tabs-heading">
      <div class="tab active">FAVORITES</div>
      <div class="tab">TAGS</div>
    </div>
    <div
      v-for="(tab, index) in tabsList"
      :key="index"
      class="tabs-content"
    >
      <div class="tab-details">
        <div class="logo-section">
          <img :src="tab.img" />
        </div>
        <div class="content-details-section">
          <h5>{{ tab.caption }}</h5>
          <span>{{ tab.solution }}</span>
          <p>Generated at {{ tab.generationDate }}</p>
        </div>
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="8"
            cy="8"
            r="6"
            stroke="#FF4751"
            stroke-width="3"
          />
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Reports',
  props: {},
  data() {
    return {
      tabsList: [
        {
          img: 'https://penmadsidrap.com/uploads/blog_image/default.jpg',
          caption: 'AD Security Assessment',
          solution: 'Active Directory',
          generationDate: '08/26/2021 9:40 PM',
        },
        {
          img: 'https://penmadsidrap.com/uploads/blog_image/default.jpg',
          caption: 'Domain Shadow Access',
          solution: 'Active Directory Permissions Analyzer',
          generationDate: '01/20/2022 4:09 AM',
        },
        {
          img: 'https://penmadsidrap.com/uploads/blog_image/default.jpg',
          caption: 'Reset Password',
          solution: 'Active Directory Permissions Analyzer',
          generationDate: '01/20/2022 4:07 AM',
        },
        {
          img: 'https://penmadsidrap.com/uploads/blog_image/default.jpg',
          caption: 'Share Details',
          solution: 'FileSystem',
          generationDate: '12/17/2021 1:21 PM',
        },
        {
          img: 'https://penmadsidrap.com/uploads/blog_image/default.jpg',
          caption: 'Weak Password Checks',
          solution: 'Active Directory',
          generationDate: '08/26/2021 9:02 PM',
        },
      ],
    };
  },
};
</script>

<style lang="less" scoped>
  .tabs-section {
    background: #fff;
  }

  .tabs-heading {
    border-bottom: 1px solid #e0e5eb;
    display: flex;

    .tab {
      text-align: center;
      flex: 0 0 156px;
      background: #eeeeee;
      padding: 10px 15px;
      font-size: 14px;
      font-weight: 600;

      &.active {
        background: #c4c4c4;
      }
    }
  }

  .tabs-content {
    padding: 16px 10px 9px 20px;
    border-bottom: 1px solid #e0e5eb;
  }

  .tab-details {
    display: flex;
  }

  .logo-section img {
    width: 40px;
    height: 40px;
    border-radius: 50%;
  }

  .content-details-section {
    width: 100%;
    padding: 3px 9px;

    h5 {
      color: #0068da;
      padding: 0;
      border: none;
      font-size: 14px;
      margin: 0 0 7px;
      letter-spacing: 0.9px;
    }

    span {
      display: inline-block;
      color: #0068da;
      font-size: 14px;
      margin-bottom: 4px;
    }

    p {
      color: #707070;
      font-size: 14px;
      margin: 0;
    }
  }

  svg {
    position: relative;
    top: 5px;
    left: 2px;
  }
</style>
